import getStorageAPIValue from './getStorageAPIValue';
import GlobalVariables from '../GlobalVariables';

const logClickEventOnGA = () => {
    function createGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 3) | 8;
            return v.toString(16);
        });
    }
    try {
        if (getStorageAPIValue('apex_ga_click_logged') != 'true') {
            const ga_url = `https://www.google-analytics.com/collect?v=1&tid=UA-41498037-4&t=event&ec=ChatStart&ea=NewChat&cid=${createGuid()}&dl=${GlobalVariables.ApexChatBaseUrl}`;
            const elem = document.createElement('img');
            elem.src = ga_url;
            elem.setAttribute('width', 1);
            elem.setAttribute('height', 1);
            elem.setAttribute('style', 'display:none;');
            document.head.appendChild(elem);
            ApexChat.storageAPI.Store('apex_ga_click_logged', true);
        }
    } catch (e) { }
};
export default logClickEventOnGA;
